import { PureComponent } from 'react';

// Icons produced by FontAwesome project: https://github.com/FortAwesome/Font-Awesome/
// License: CC-By 4.0

export class FourCellsGridIcon extends PureComponent {
  render() {
    return (
      <svg viewBox="0 0 512 512" {...this.props}>
        <path
          fill="currentColor"
          d="M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
        ></path>
      </svg>
    );
  }
}

export class NineCellsGridIcon extends PureComponent {
  render() {
    return (
      <svg viewBox="0 0 512 512" {...this.props}>
        <path
          fill="currentColor"
          d="m 486.00705,153.73436 c -103.64073,0.23188 -207.33187,-0.46077 -310.94157,0.34102 -14.42404,1.95848 -23.66609,17.09242 -21.4033,31.00963 0.23203,101.71563 -0.46098,203.48171 0.34101,305.16629 1.95842,14.42448 17.09189,23.66681 31.00867,21.40396 101.71249,-0.23203 203.47542,0.461 305.15687,-0.34102 14.42404,-1.95848 23.66609,-17.09241 21.40331,-31.00962 -0.23204,-101.71563 0.46097,-203.48171 -0.34102,-305.1663 -1.81786,-12.10893 -12.97212,-21.58074 -25.22397,-21.40396 z m -25.56499,51.13156 c 0,34.08771 0,68.1754 0,102.26311 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.08771 0,-68.1754 0,-102.26311 34.08665,0 68.1733,0 102.25996,0 z m -153.38994,0 c 0,34.08771 0,68.1754 0,102.26311 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.08771 0,-68.1754 0,-102.26311 34.08665,0 68.1733,0 102.25996,0 z M 204.79216,460.52371 c 0,-34.08772 0,-68.17541 0,-102.26312 34.08665,0 68.1733,0 102.25996,0 0,34.08771 0,68.1754 0,102.26312 -34.08666,0 -68.17331,0 -102.25996,0 z m 153.38994,0 c 0,-34.08772 0,-68.17541 0,-102.26312 34.08665,0 68.1733,0 102.25996,0 0,34.08771 0,68.1754 0,102.26312 -34.08666,0 -68.17331,0 -102.25996,0 z M 25.837664,0.3400662 C 10.365229,-0.13719655 -2.0116541,15.212598 0.27267363,30.244498 0.46152699,183.45039 -0.10425818,336.69362 0.55460752,489.87625 2.311889,504.47035 17.570146,513.96069 31.622358,511.65564 c 101.712482,-0.23204 203.475412,0.46099 305.156862,-0.34103 14.42404,-1.95848 23.66609,-17.09241 21.40331,-31.00962 0,-40.68135 0,-81.36268 0,-122.04402 44.23209,-0.35234 88.5545,0.68213 132.73459,-0.47588 14.72857,-2.42922 23.12372,-18.28961 20.65535,-32.321 C 511.34039,224.23055 512.0335,122.94654 511.23146,21.744035 509.27303,7.3195449 494.13957,-1.9227849 480.22278,0.3400662 c -151.4617,0 -302.92341,0 -454.385116,0 z m 25.56499,51.1315548 c 34.086649,0 68.173296,0 102.259956,0 0,34.087709 0,68.175409 0,102.263109 -34.08666,0 -68.173307,0 -102.259956,0 0,-34.0877 0,-68.1754 0,-102.263109 z m 153.389936,0 c 34.08665,0 68.1733,0 102.25996,0 0,34.087709 0,68.175409 0,102.263109 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.0877 0,-68.1754 0,-102.263109 z m 153.38994,0 c 34.08665,0 68.1733,0 102.25996,0 0,34.087709 0,68.175409 0,102.263109 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.0877 0,-68.1754 0,-102.263109 z M 51.402654,204.8663 c 34.086649,0 68.173296,0 102.259956,0 0,34.0877 0,68.1754 0,102.26311 -34.08666,0 -68.173307,0 -102.259956,0 0,-34.08771 0,-68.17541 0,-102.26311 z m 153.389936,0 c 34.08665,0 68.1733,0 102.25996,0 0,34.0877 0,68.1754 0,102.26311 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.08771 0,-68.17541 0,-102.26311 z m 153.38994,0 c 34.08665,0 68.1733,0 102.25996,0 0,34.0877 0,68.1754 0,102.26311 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.08771 0,-68.17541 0,-102.26311 z M 51.402654,358.26097 c 34.086649,0 68.173296,0 102.259956,0 0,34.0877 0,68.1754 0,102.26312 -34.08666,0 -68.173307,0 -102.259956,0 0,-34.08772 0,-68.17542 0,-102.26312 z m 153.389936,0 c 34.08665,0 68.1733,0 102.25996,0 0,34.0877 0,68.1754 0,102.26312 -34.08666,0 -68.17331,0 -102.25996,0 0,-34.08772 0,-68.17542 0,-102.26312 z"
          style={{ strokeWidth: 0.798918 }}
        />
      </svg>
    );
  }
}

export class FilledNineCellsGridIcon extends PureComponent {
  render() {
    return (
      <svg enable-background="new 0 0 32 32" viewBox="0 0 32 32" {...this.props}>
        <g id="grid-2">
          <path
            d="M10.246,4.228c0-0.547-0.443-0.991-0.99-0.991H3.914c-0.548,0-0.991,0.443-0.991,0.991V9.57   c0,0.546,0.443,0.99,0.991,0.99h5.342c0.547,0,0.99-0.444,0.99-0.99V4.228z"
            fill="currentColor"
          />
          <path
            d="M19.453,4.228c0-0.547-0.443-0.991-0.991-0.991h-5.343c-0.546,0-0.99,0.443-0.99,0.991V9.57   c0,0.546,0.444,0.99,0.99,0.99h5.343c0.548,0,0.991-0.444,0.991-0.99V4.228z"
            fill="currentColor"
          />
          <path
            d="M28.868,4.228c0-0.547-0.443-0.991-0.99-0.991h-5.342c-0.548,0-0.991,0.443-0.991,0.991V9.57   c0,0.546,0.443,0.99,0.991,0.99h5.342c0.547,0,0.99-0.444,0.99-0.99V4.228z"
            fill="currentColor"
          />
          <path
            d="M10.246,13.224c0-0.547-0.443-0.99-0.99-0.99H3.914c-0.548,0-0.991,0.443-0.991,0.99v5.342   c0,0.549,0.443,0.99,0.991,0.99h5.342c0.547,0,0.99-0.441,0.99-0.99V13.224z"
            fill="currentColor"
          />
          <path
            d="M19.453,13.224c0-0.547-0.443-0.99-0.991-0.99h-5.343c-0.546,0-0.99,0.443-0.99,0.99v5.342   c0,0.549,0.444,0.99,0.99,0.99h5.343c0.548,0,0.991-0.441,0.991-0.99V13.224z"
            fill="currentColor"
          />
          <path
            d="M28.868,13.224c0-0.547-0.443-0.99-0.99-0.99h-5.342c-0.548,0-0.991,0.443-0.991,0.99v5.342   c0,0.549,0.443,0.99,0.991,0.99h5.342c0.547,0,0.99-0.441,0.99-0.99V13.224z"
            fill="currentColor"
          />
          <path
            d="M10.246,22.43c0-0.545-0.443-0.99-0.99-0.99H3.914c-0.548,0-0.991,0.445-0.991,0.99v5.344   c0,0.547,0.443,0.99,0.991,0.99h5.342c0.547,0,0.99-0.443,0.99-0.99V22.43z"
            fill="currentColor"
          />
          <path
            d="M19.453,22.43c0-0.545-0.443-0.99-0.991-0.99h-5.343c-0.546,0-0.99,0.445-0.99,0.99v5.344   c0,0.547,0.444,0.99,0.99,0.99h5.343c0.548,0,0.991-0.443,0.991-0.99V22.43z"
            fill="currentColor"
          />
          <path
            d="M28.868,22.43c0-0.545-0.443-0.99-0.99-0.99h-5.342c-0.548,0-0.991,0.445-0.991,0.99v5.344   c0,0.547,0.443,0.99,0.991,0.99h5.342c0.547,0,0.99-0.443,0.99-0.99V22.43z"
            fill="currentColor"
          />
        </g>
      </svg>
    );
  }
}
